<template>
  <div class="head-container">
    <div class="header-wrap safe-wrapper">
      <div class="h-l">
        <span>Hi~欢迎加入康养合规专业委员会</span>
      </div>
    </div>
    <div class="nav-banner">
      <div class="nav-banner-main safe-wrapper">
        <div class="banner-main-l">
          <span class="banner-logo">
            <img src="../assets/image/hgs-logo2.png" alt="" />
          </span>
          <h1 class="banner-title">
            <span class="banner-txt">
              <span class="banner-title-text"
                >养老合规师职业能力<span class="index-notice-none"
                  >（水平）</span
                >考试</span
              >
            </span>

            <span class="banner-title-tips"
              >养老合规师考试网 <span>www.yanglao365.org.cn</span></span
            >
          </h1>
        </div>
      </div>
    </div>

    <div class="nav-list">
      <div class="nav-menu-list safe-wrapper">
        <div
          :class="`${activeMenu == item.jump_url ? 'hover' : ''}`"
          v-for="(item, index) in menusList"
          :key="index"
        >
          <router-link
            :to="`${
              item.jump_url == '/Home'
                ? '/Home'
                : item.jump_url + '?menu_id=' + item.id
            }`"
            >{{ item.menu_name }}</router-link
          >
        </div>
      </div>
    </div>
    <!-- 最新公告 -->
    <div class="announcement-wrapper" v-if="is_show">
      <div class="announcement-content">
        <div class="announcement-content-left">
          <img src="../assets/image/icon-suona.jpg" />
          <span>最新公告</span>
        </div>
        <div class="announcement-content-right" style="height: 48px">
          <div class="str_move">
            <a
              href="javascript:0;"
              v-for="(item, index) in ggtz_info.news_list"
              :key="index"
              class="notice-bar__wrap_text"
              @click="
                clickItems(item.id, ggtz_info.main_title)
              "
            >
              {{ item.title }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMenus, getHome } from "../api/api";
export default {
  components: {},
  data() {
    return {
      ggtz_info: {}, // 公告通知
      menusList: [],
      is_show: true,
    };
  },
  watch: {
    $route() {
      this.setCurrentRoute();
    },
  },
  computed: {
    // avatar() {
    //   return this.$store.state.user.realAvatar
    // },
    activeMenu() {
      const route = this.$route;
      console.log(route);
      const { meta, path, fullPath } = route;
      return "" || path;
    },
  },

  mounted() {},
  created() {
    this.setCurrentRoute();
    this.getMenus();
    this.getHome();
  },
  methods: {
    getMenus() {
      let that = this;
      getMenus({})
        .then((res) => {
          if (res.code == 0) {
            that.menusList = res.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    setCurrentRoute() {
      console.log(this.$route.path);
      if (this.$route.path != "/Home") {
        this.is_show = false;
      } else {
        this.is_show = true;
      }
    },
    goToHome() {
      this.$router.push({
        path: "/Home",
        query: {},
      });
    },
    search(e) {},
    getHome() {
      let that = this;
      getHome({})
        .then((res) => {
          if (res.code == 0) {
            let data = res.data.list;
            data.forEach((ele) => {
              if (ele.id == 1) {
                that.ggtz_info = ele;
                that.ggtz_info.news_list = ele.news_list.slice(0, 5);
              }
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    clickItems(i, t) {
      this.$router.push({
        path: "/details",
        query: {
          id: i,
          title: t,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.head-container {
  box-shadow: 0 0 6px -3px #999;
}

.safe-wrapper {
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 0 1rem;
  box-sizing: border-box;
}

.header-wrap {
  display: flex;
  justify-content: space-between;
  height: 2.5rem;
}

.h-l,
.h-r {
  display: flex;
  align-items: center;
}

.h-l span {
  font-size: 0.75rem;
  color: #666;
  padding-left: 0.625rem;
}

.nav-banner {
  width: 100%;
  height: clamp(150px, 30vw, 260px);
  background: $g_bg;
  color: #fff;
  // background-image: linear-gradient(to bottom, #33adb3,#3584a7,#406393);
  background-size: 500%;
  animation: bgAnimation 15s linear infinite;
  background-image: url(../assets/image/nav-banner-new.png);
  background-size: cover;
  background-repeat: no-repeat;
}

.nav-list {
  width: 100%;
  height: 3.4375rem;
  background-color: $g_nav_bg;
  display: none;
}

.nav-banner-main {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
}

.banner-main-l {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem 0.5rem;
  min-width: 0;
}

.banner-main-l .banner-logo {
  width: clamp(7.25rem, 20vw, 11.875rem);
  height: clamp(7.25rem, 20vw, 11.875rem);
  border-radius: 50%;
  margin-right: clamp(1rem, 3vw, 1.625rem);
  margin-left: clamp(-0.625rem, -2vw, -0.625rem);
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  flex-shrink: 0;
}

.banner-main-l .banner-logo img {
  width: 100%;
  height: 100%;
}
h1 {
  font-size: clamp(1rem, 3vw, 1.25rem);
}
.banner-main-l .banner-title {
  color: #fff;
  letter-spacing: 0.0625rem;
}

.banner-main-l .banner-title .banner-txt {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.banner-main-l .banner-title .banner-title-text {
  display: block;
  font-size: clamp(1.125rem, 4.8vw, 3.125rem);
  // font-weight: 600;
  margin-bottom: 0.1875rem;
}

.index-notice-none {
  display: none;
}

.banner-main-l .banner-title .banner-title-tips {
  display: block;
  font-size: clamp(1.125rem, 4vw, 2.125rem);
}

.banner-main-l .banner-title .banner-title-tips span {
  display: inline-block;
  font-size: clamp(0.875rem, 3vw, 1.375rem);
}

.nav-menu-list {
  align-items: center;
  height: 100%;
  background: $g_nav_bg;

  & > div {
    flex: 1;
    height: 3.4375rem;
    line-height: 3.4375rem;
    min-width: clamp(5rem, 20vw, 7.5rem);
    font-size: clamp(0.75rem, 2.5vw, 0.875rem);
    text-align: center;
    padding: 0 0.625rem;
    color: #fff !important;
  }

  & > div > a {
    color: #fff !important;
    font-size: clamp(0.8125rem, 2.5vw, 0.9375rem);
    width: 100%;
    height: 100%;
    display: inline-block;
  }
}

.announcement-wrapper {
  width: 100%;
  height: 3rem;
  background: #dae9ff;
}

.announcement-wrapper .announcement-content {
  width: 100%;
  max-width: 1200px;
  height: 3rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  box-sizing: border-box;
}

.announcement-content-left {
  height: 2.125rem;
  width: clamp(5.5rem, 20vw, 6.25rem);
  background-image: url(../assets/image/suona-bg.jpg);
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 0.625rem;
}

.announcement-content-left img {
  width: clamp(1rem, 3vw, 1.1875rem);
  height: clamp(0.875rem, 3vw, 1.0625rem);
  margin-right: 0.25rem;
  margin-left: 0.625rem;
}

.announcement-content-left span {
  color: #fff;
  font-size: clamp(0.75rem, 2.5vw, 0.8125rem);
}

.announcement-content-right {
  flex: 1;
  background: #dae9ff;
  overflow: hidden;
  position: relative;
}

.str_move {
  white-space: nowrap;
  height: 100%;
  cursor: move;
  animation: move 26s linear infinite;
  display: flex;
  width: max-content;
  &::after {
    content: attr(data-content);
    padding-left: clamp(1.875rem, 5vw, 3.75rem);
  }
}

.str_move a.notice-bar__wrap_text {
  font-size: clamp(0.75rem, 2.5vw, 0.875rem);
  font-weight: 500;
  color: $g_color;
  line-height: 3rem;
  padding-right: clamp(1.875rem, 5vw, 3.75rem);
}

@keyframes move {
  0% {
    transform: translateX(5%);
  }
  100% {
    transform: translateX(-100%);
  }
}

/* 平板及以上设备显示导航菜单 */
@media screen and (min-width: 768px) {
  .nav-list {
    display: block;
  }

  .nav-banner {
    background-image: url(../assets/image/nav-banner-new.png);
    background-size: cover, cover;
    background-position: center, center;
  }

  .nav-menu-list {
    display: flex;
    align-items: center;
    height: 100%;
    background: $g_nav_bg;

    & > div {
      flex: 1;
      height: 55px;
      line-height: 55px;
      min-width: 120px;
      font-size: 14px;
      text-align: center;
      padding: 0 10px;
      color: #fff !important;
    }

    & > div > a {
      color: #fff !important;
      font-size: 15px;
      width: 100%;
      height: 100%;
      display: inline-block;
    }

    & > div.hover,
    & > div:hover {
      background-color: $g_nav_active_bg !important;
      border-bottom: none !important;
    }

    /deep/ .el-menu {
      background: $g_nav_bg;
    }

    /deep/ .el-menu--horizontal > .el-menu-item {
      height: 55px;
      line-height: 55px;
      min-width: 120px;
      font-size: 14px;
      text-align: center;
      padding: 0 10px;
    }

    /deep/ .el-menu--horizontal > .el-menu-item.is-active {
      background-color: $g_nav_active_bg !important;
      border-bottom: none !important;
    }

    /deep/ .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
    /deep/ .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
    /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
      background-color: $g_nav_active_bg !important;
    }
  }

  .banner-main-l .banner-title .banner-title-text {
    display: block;
    font-size: clamp(1.125rem, 5vw, 3.125rem);
    margin-bottom: 0.1875rem;
  }

  .index-notice-none {
    display: inline-block;
  }

  .str_move {
    white-space: nowrap;
    height: 100%;
    cursor: move;
    animation: move 26s linear infinite;
  }

  @keyframes move {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
}

/* 大屏设备优化 */
@media screen and (min-width: 1200px) {
  .safe-wrapper {
    padding: 0;
  }

  .announcement-wrapper .announcement-content {
    padding: 0;
  }
}
</style>
